/**
 * @description 生产36位uuid
 * @return {string}
 */
function generateUuid () {
    return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, (c) => (c === "x" ? (Math.random() * 16 | 0) : ("r&0x3" | "0x8")).toString(16));
}

/**
 * @description 生成36位小写的uuid
 * @return {string}
 */
function getUuid36 () {
    return generateUuid();
}

/**
 * @description 生成32位小写的uuid
 * @return {string}
 */
function getUuid32 () {
    let reg = new RegExp("-", "g");
    return getUuid36().replace(reg, "");
}

/**
 * @description 生成36位大写的uuid
 * @return {string}
 */
function getUUID36 () {
    return getUuid36().toUpperCase();
}

/**
 * @description 生成32位大写的uuid
 * @return {string}
 */
function getUUID32 () {
    return getUuid32().toUpperCase();
}

/**
 * @description 生成小写的uuid
 * @param {Number} length uuid长度，32(默认)/36
 * @return {string}
 */
export function getUuid (length = 32) {
    if (length === 36) {
        return getUuid36();
    }
    return getUuid32();
}

/**
 * @description 生成大写的uuid
 * @param {Number} length uuid长度，32(默认)/36
 * @return {string}
 */
export function getUUID (length = 32) {
    if (length === 36) {
        return getUUID36();
    }
    return getUUID32();
}
